"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanxTokenStakeState = exports.BanxStakingSettingsState = exports.BanxAdventureState = exports.BanxAdventureSubscriptionState = exports.CallState = exports.LenderLeaderboardState = exports.RoundState = exports.AdventureState = exports.BanxStakeState = exports.BondEventType = exports.AutocompoundType = exports.BondTradeTransactionV2Type = exports.AutocompoundDepositState = exports.NftBoxState = exports.NftBoxType = exports.NftValidationDurationType = exports.ScopeType = exports.AuthorityState = exports.AuthorityType = exports.PairAuthorityType = exports.PairState = exports.RedeemResult = exports.LendingTokenType = exports.RepayDestination = exports.WhitelistType = exports.PairTokenType = exports.PairValidationType = exports.MarketTrustType = exports.MarketState = exports.OrderType = exports.NftValidationWhitelistType = exports.PairType = exports.BondingCurveType = exports.BondFeatures = exports.CollateralBoxType = exports.BondTradeTransactionV2State = exports.FraktBondState = void 0;
var FraktBondState;
(function (FraktBondState) {
    FraktBondState["Initialized"] = "initialized";
    FraktBondState["Active"] = "active";
    FraktBondState["Repaid"] = "repaid";
    FraktBondState["Liquidating"] = "liquidating";
    FraktBondState["Liquidated"] = "liquidated";
    FraktBondState["PerpetualActive"] = "perpetualActive";
    FraktBondState["PerpetualRepaid"] = "perpetualRepaid";
    FraktBondState["PerpetualLiquidatedByAuction"] = "perpetualLiquidatedByAuction";
    FraktBondState["PerpetualLiquidatedByClaim"] = "perpetualLiquidatedByClaim";
})(FraktBondState = exports.FraktBondState || (exports.FraktBondState = {}));
var BondTradeTransactionV2State;
(function (BondTradeTransactionV2State) {
    BondTradeTransactionV2State["NotActive"] = "notActive";
    BondTradeTransactionV2State["Active"] = "active";
    BondTradeTransactionV2State["PerpetualActive"] = "perpetualActive";
    BondTradeTransactionV2State["PerpetualRepaid"] = "perpetualRepaid";
    BondTradeTransactionV2State["PerpetualLiquidatedByAuction"] = "perpetualLiquidatedByAuction";
    BondTradeTransactionV2State["PerpetualLiquidatedByClaim"] = "perpetualLiquidatedByClaim";
    BondTradeTransactionV2State["PerpetualManualTerminating"] = "perpetualManualTerminating";
    BondTradeTransactionV2State["PerpetualPartialRepaid"] = "perpetualPartialRepaid";
    BondTradeTransactionV2State["PerpetualRefinanceRepaid"] = "perpetualRefinanceRepaid";
    BondTradeTransactionV2State["PerpetualRefinancedActive"] = "perpetualRefinancedActive";
    BondTradeTransactionV2State["Migrated"] = "migrated";
})(BondTradeTransactionV2State = exports.BondTradeTransactionV2State || (exports.BondTradeTransactionV2State = {}));
var CollateralBoxType;
(function (CollateralBoxType) {
    CollateralBoxType["Escrow"] = "escrow";
    CollateralBoxType["Escrowless"] = "escrowless";
})(CollateralBoxType = exports.CollateralBoxType || (exports.CollateralBoxType = {}));
var BondFeatures;
(function (BondFeatures) {
    BondFeatures["None"] = "none";
    BondFeatures["Autocompound"] = "autocompound";
    BondFeatures["ReceiveNftOnLiquidation"] = "receiveNftOnLiquidation";
    BondFeatures["AutoreceiveSol"] = "autoreceiveSol";
    BondFeatures["AutoCompoundAndReceiveNft"] = "autoCompoundAndReceiveNft";
    BondFeatures["AutoReceiveAndReceiveNft"] = "autoReceiveAndReceiveNft";
})(BondFeatures = exports.BondFeatures || (exports.BondFeatures = {}));
var BondingCurveType;
(function (BondingCurveType) {
    BondingCurveType["Linear"] = "linear";
    BondingCurveType["Exponential"] = "exponential";
})(BondingCurveType = exports.BondingCurveType || (exports.BondingCurveType = {}));
var PairType;
(function (PairType) {
    PairType["TokenForNFT"] = "tokenForNft";
    PairType["NftForToken"] = "nftForToken";
    PairType["LiquidityProvision"] = "liquidityProvision";
})(PairType = exports.PairType || (exports.PairType = {}));
var NftValidationWhitelistType;
(function (NftValidationWhitelistType) {
    NftValidationWhitelistType["Creator"] = "creator";
    NftValidationWhitelistType["Nft"] = "nft";
    NftValidationWhitelistType["MerkleTree"] = "merkleTree";
    NftValidationWhitelistType["CollectionId"] = "collectionId";
})(NftValidationWhitelistType = exports.NftValidationWhitelistType || (exports.NftValidationWhitelistType = {}));
var OrderType;
(function (OrderType) {
    OrderType["Buy"] = "buy";
    OrderType["Sell"] = "sell";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var MarketState;
(function (MarketState) {
    MarketState["Initializing"] = "initializing";
    MarketState["Available"] = "available";
    MarketState["InitializingPerpetual"] = "initializingPerpetual";
    MarketState["AvailablePerpetual"] = "availablePerpetual";
    MarketState["PrivateAvailablePerpetual"] = "privateAvailablePerpetual";
})(MarketState = exports.MarketState || (exports.MarketState = {}));
var MarketTrustType;
(function (MarketTrustType) {
    MarketTrustType["Unverified"] = "unverified";
    MarketTrustType["Verified"] = "verified";
})(MarketTrustType = exports.MarketTrustType || (exports.MarketTrustType = {}));
var PairValidationType;
(function (PairValidationType) {
    PairValidationType["ClassicValidation"] = "classicValidation";
    PairValidationType["CustomValidation"] = "customValidation";
})(PairValidationType = exports.PairValidationType || (exports.PairValidationType = {}));
var PairTokenType;
(function (PairTokenType) {
    PairTokenType["NativeSol"] = "nativeSol";
    PairTokenType["Spl"] = "spl";
})(PairTokenType = exports.PairTokenType || (exports.PairTokenType = {}));
var WhitelistType;
(function (WhitelistType) {
    WhitelistType["Nft"] = "nft";
    WhitelistType["Creator"] = "creator";
})(WhitelistType = exports.WhitelistType || (exports.WhitelistType = {}));
var RepayDestination;
(function (RepayDestination) {
    RepayDestination["None"] = "none";
    RepayDestination["Offer"] = "offer";
    RepayDestination["Wallet"] = "wallet";
    RepayDestination["Vault"] = "vault";
})(RepayDestination = exports.RepayDestination || (exports.RepayDestination = {}));
var LendingTokenType;
(function (LendingTokenType) {
    LendingTokenType["NativeSOL"] = "nativeSol";
    LendingTokenType["USDC"] = "usdc";
})(LendingTokenType = exports.LendingTokenType || (exports.LendingTokenType = {}));
var RedeemResult;
(function (RedeemResult) {
    RedeemResult["None"] = "none";
    RedeemResult["DirectBorrow"] = "directBorrow";
    RedeemResult["Reborrow"] = "reborrow";
    RedeemResult["InstantRefinanced"] = "instantRefinanced";
    RedeemResult["RefinancedByAuction"] = "refinancedByAuction";
    RedeemResult["PartialRepay"] = "partialRepay";
    RedeemResult["DirectRepaid"] = "directRepaid";
    RedeemResult["Claimed"] = "claimed";
    RedeemResult["DirectBorrowAndDirectRepaid"] = "directBorrowAndDirectRepaid";
    RedeemResult["DirectBorrowAndReborrowRepaid"] = "directBorrowAndReborrowRepaid";
    RedeemResult["DirectBorrowAndInstantRefinancedRepaid"] = "directBorrowAndInstantRefinancedRepaid";
    RedeemResult["DirectBorrowAndRefinancedByAuctionRepaid"] = "directBorrowAndRefinancedByAuctionRepaid";
    RedeemResult["DirectBorrowAndPartialRepaid"] = "directBorrowAndPartialRepaid";
    RedeemResult["DirectBorrowAndClaimed"] = "directBorrowAndClaimed";
    RedeemResult["ReborrowAndDirectRepaid"] = "reborrowAndDirectRepaid";
    RedeemResult["ReborrowAndReborrowRepaid"] = "reborrowAndReborrowRepaid";
    RedeemResult["ReborrowAndInstantRefinancedRepaid"] = "reborrowAndInstantRefinancedRepaid";
    RedeemResult["ReborrowAndRefinancedByAuctionRepaid"] = "reborrowAndRefinancedByAuctionRepaid";
    RedeemResult["ReborrowAndPartialRepaid"] = "reborrowAndPartialRepaid";
    RedeemResult["ReborrowAndClaimed"] = "reborrowAndClaimed";
    RedeemResult["InstantRefinancedAndDirectRepaid"] = "instantRefinancedAndDirectRepaid";
    RedeemResult["InstantRefinancedAndReborrowRepaid"] = "instantRefinancedAndReborrowRepaid";
    RedeemResult["InstantRefinancedAndInstantRefinancedRepaid"] = "instantRefinancedAndInstantRefinancedRepaid";
    RedeemResult["InstantRefinancedAndRefinancedByAuctionRepaid"] = "instantRefinancedAndRefinancedByAuctionRepaid";
    RedeemResult["InstantRefinancedAndPartialRepaid"] = "instantRefinancedAndPartialRepaid";
    RedeemResult["InstantRefinancedAndClaimed"] = "instantRefinancedAndClaimed";
    RedeemResult["RefinancedByAuctionAndDirectRepaid"] = "refinancedByAuctionAndDirectRepaid";
    RedeemResult["RefinancedByAuctionAndReborrowRepaid"] = "refinancedByAuctionAndReborrowRepaid";
    RedeemResult["RefinancedByAuctionAndInstantRefinancedRepaid"] = "refinancedByAuctionAndInstantRefinancedRepaid";
    RedeemResult["RefinancedByAuctionAndRefinancedByAuctionRepaid"] = "refinancedByAuctionAndRefinancedByAuctionRepaid";
    RedeemResult["RefinancedByAuctionAndPartialRepaid"] = "refinancedByAuctionAndPartialRepaid";
    RedeemResult["RefinancedByAuctionAndClaimed"] = "refinancedByAuctionAndClaimed";
    RedeemResult["PartialRepaidAndDirectRepaid"] = "partialRepaidAndDirectRepaid";
    RedeemResult["PartialRepaidAndReborrowRepaid"] = "partialRepaidAndReborrowRepaid";
    RedeemResult["PartialRepaidAndInstantRefinancedRepaid"] = "partialRepaidAndInstantRefinancedRepaid";
    RedeemResult["PartialRepaidAndRefinancedByAuctionRepaid"] = "partialRepaidAndRefinancedByAuctionRepaid";
    RedeemResult["PartialRepaidAndPartialRepaid"] = "partialRepaidAndPartialRepaid";
    RedeemResult["PartialRepaidAndClaimed"] = "partialRepaidAndClaimed";
})(RedeemResult = exports.RedeemResult || (exports.RedeemResult = {}));
var PairState;
(function (PairState) {
    PairState["Initializing"] = "initializing";
    PairState["OnMarketVirtual"] = "onMarketVirtual";
    PairState["OnMarketTokenized"] = "onMarketTokenized";
    PairState["Frozen"] = "frozen";
    PairState["Closed"] = "closed";
    PairState["PerpetualMigrated"] = "perpetualMigrated";
    PairState["PerpetualOnMarket"] = "perpetualOnMarket";
    PairState["PerpetualClosed"] = "perpetualClosed";
    PairState["PerpetualBondingCurveOnMarket"] = "perpetualBondingCurveOnMarket";
    PairState["PerpetualBondingCurveClosed"] = "perpetualBondingCurveClosed";
})(PairState = exports.PairState || (exports.PairState = {}));
var PairAuthorityType;
(function (PairAuthorityType) {
    PairAuthorityType["ClassicAuthority"] = "classicAuthority";
    PairAuthorityType["CustomAuthority"] = "customAuthority";
})(PairAuthorityType = exports.PairAuthorityType || (exports.PairAuthorityType = {}));
var AuthorityType;
(function (AuthorityType) {
    AuthorityType["Persistent"] = "persistent";
    AuthorityType["OneTime"] = "oneTime";
})(AuthorityType = exports.AuthorityType || (exports.AuthorityType = {}));
var AuthorityState;
(function (AuthorityState) {
    AuthorityState["Active"] = "active";
    AuthorityState["Used"] = "used";
    AuthorityState["Expired"] = "expired";
    AuthorityState["Revoked"] = "revoked";
})(AuthorityState = exports.AuthorityState || (exports.AuthorityState = {}));
var ScopeType;
(function (ScopeType) {
    ScopeType["Market"] = "market";
    ScopeType["Pair"] = "pair";
})(ScopeType = exports.ScopeType || (exports.ScopeType = {}));
var NftValidationDurationType;
(function (NftValidationDurationType) {
    NftValidationDurationType["Finite"] = "finite";
    NftValidationDurationType["Infinite"] = "infinite";
})(NftValidationDurationType = exports.NftValidationDurationType || (exports.NftValidationDurationType = {}));
var NftBoxType;
(function (NftBoxType) {
    NftBoxType["Escrow"] = "escrow";
    NftBoxType["Escrowless"] = "escrowless";
})(NftBoxType = exports.NftBoxType || (exports.NftBoxType = {}));
var NftBoxState;
(function (NftBoxState) {
    NftBoxState["NotActive"] = "notActive";
    NftBoxState["Active"] = "active";
})(NftBoxState = exports.NftBoxState || (exports.NftBoxState = {}));
var AutocompoundDepositState;
(function (AutocompoundDepositState) {
    AutocompoundDepositState["NotActive"] = "notActive";
    AutocompoundDepositState["Active"] = "active";
    AutocompoundDepositState["Removed"] = "removed";
})(AutocompoundDepositState = exports.AutocompoundDepositState || (exports.AutocompoundDepositState = {}));
var BondTradeTransactionV2Type;
(function (BondTradeTransactionV2Type) {
    BondTradeTransactionV2Type["None"] = "none";
    BondTradeTransactionV2Type["Autocompound"] = "autocompound";
    BondTradeTransactionV2Type["ReceiveNftOnLiquidation"] = "receiveNftOnLiquidation";
    BondTradeTransactionV2Type["AutoreceiveSol"] = "autoreceiveSol";
    BondTradeTransactionV2Type["AutoCompoundAndReceiveNft"] = "autoCompoundAndReceiveNft";
    BondTradeTransactionV2Type["AutoReceiveAndReceiveNft"] = "autoReceiveAndReceiveNft";
})(BondTradeTransactionV2Type = exports.BondTradeTransactionV2Type || (exports.BondTradeTransactionV2Type = {}));
var AutocompoundType;
(function (AutocompoundType) {
    AutocompoundType["Autocompound"] = "autocompound";
    AutocompoundType["AutoreceiveSol"] = "autoreceiveSol";
    AutocompoundType["AutocompoundAndReceiveNft"] = "autocompoundAndReceiveNft";
})(AutocompoundType = exports.AutocompoundType || (exports.AutocompoundType = {}));
var BondEventType;
(function (BondEventType) {
    BondEventType["Creation"] = "creation";
    BondEventType["Repay"] = "repay";
    BondEventType["Liquidating"] = "liquidating";
    BondEventType["Liquidated"] = "liquidated";
    BondEventType["Redeem"] = "redeem";
    BondEventType["Refinance"] = "refinance";
})(BondEventType = exports.BondEventType || (exports.BondEventType = {}));
var BanxStakeState;
(function (BanxStakeState) {
    BanxStakeState["Staked"] = "staked";
    BanxStakeState["Unstaked"] = "unstaked";
    BanxStakeState["Liquidated"] = "liquidated";
})(BanxStakeState = exports.BanxStakeState || (exports.BanxStakeState = {}));
var AdventureState;
(function (AdventureState) {
    AdventureState["Uninitialized"] = "uninitialized";
    AdventureState["Initialized"] = "initialized";
    AdventureState["DistributingInitialized"] = "distributingInitialized";
})(AdventureState = exports.AdventureState || (exports.AdventureState = {}));
var RoundState;
(function (RoundState) {
    RoundState["Uninitialized"] = "uninitialized";
    RoundState["Initialized"] = "initialized";
    RoundState["Open"] = "open";
    RoundState["Drawn"] = "drawn";
})(RoundState = exports.RoundState || (exports.RoundState = {}));
var LenderLeaderboardState;
(function (LenderLeaderboardState) {
    LenderLeaderboardState["Uninitialized"] = "uninitialized";
    LenderLeaderboardState["Initialized"] = "initialized";
    LenderLeaderboardState["Removed"] = "removed";
})(LenderLeaderboardState = exports.LenderLeaderboardState || (exports.LenderLeaderboardState = {}));
var CallState;
(function (CallState) {
    CallState["Uninitialized"] = "uninitialized";
    CallState["Initialized"] = "initialized";
})(CallState = exports.CallState || (exports.CallState = {}));
var BanxAdventureSubscriptionState;
(function (BanxAdventureSubscriptionState) {
    BanxAdventureSubscriptionState["None"] = "none";
    BanxAdventureSubscriptionState["Active"] = "active";
    BanxAdventureSubscriptionState["Claimed"] = "claimed";
})(BanxAdventureSubscriptionState = exports.BanxAdventureSubscriptionState || (exports.BanxAdventureSubscriptionState = {}));
var BanxAdventureState;
(function (BanxAdventureState) {
    BanxAdventureState["None"] = "none";
    BanxAdventureState["Active"] = "active";
})(BanxAdventureState = exports.BanxAdventureState || (exports.BanxAdventureState = {}));
var BanxStakingSettingsState;
(function (BanxStakingSettingsState) {
    BanxStakingSettingsState["None"] = "none";
    BanxStakingSettingsState["Active"] = "active";
})(BanxStakingSettingsState = exports.BanxStakingSettingsState || (exports.BanxStakingSettingsState = {}));
var BanxTokenStakeState;
(function (BanxTokenStakeState) {
    BanxTokenStakeState["None"] = "none";
    BanxTokenStakeState["Staked"] = "staked";
    BanxTokenStakeState["Unstaked"] = "unstaked";
})(BanxTokenStakeState = exports.BanxTokenStakeState || (exports.BanxTokenStakeState = {}));
